import {
  delete_patient_file,
  load_patient_file_list,
  upload_patient_file,
} from "../../actions/clinic_content";
import DocumentList from "../DocumentList";

const PatientDocumentList = ({ pacienteId }) => {
  const documentListConfig = {
    loadFunction: load_patient_file_list,
    uploadFunction: upload_patient_file,
    deleteFunction: delete_patient_file,
  };
  
  return (
    <DocumentList
      personId={pacienteId}
      documentListConfig={documentListConfig}
    />
  );
};

export default PatientDocumentList;
